import React from 'react'
import { observer, Observer } from 'mobx-react-lite'
import { AppInputDynamicPadding } from '../../../../ui/molecules'
import { Spacer } from '../../../../ui/atoms'
import { View } from 'react-native'
import { dictionaries, ICardEntryModel } from '@linqpal/models'
import { supplier } from '@linqpal/common-frontend'
import CustomerPaymentMethod from '../../../Supplier/Account/Sidebar/AccountSidebarView/AddCustomerPaymentMethod/CustomerPaymentMethodStore'
import { useTranslation } from 'react-i18next'
import { BtButton } from '@linqpal/components/src/ui'

interface AddressDetailsProps {
  onAction: () => void
  model: ICardEntryModel
}

export const AddressDetails: React.FC<AddressDetailsProps> = observer(
  ({ onAction, model }) => {
    const { t } = useTranslation('global')
    const { addModal } = CustomerPaymentMethod
    const { Picker } = supplier.ui
    return (
      <View>
        <Spacer height={6} />
        <AppInputDynamicPadding
          label={t('AddCard.street-address') as string}
          model={model}
          name="addressLine1"
          mandatory
        />
        <AppInputDynamicPadding
          label={t('AddCard.apt-ste-bldg') as string}
          model={model}
          name="addressLine2"
        />
        <AppInputDynamicPadding
          label={t('AddCard.city') as string}
          model={model}
          name="city"
          mandatory
        />
        <Picker
          label={t('AddCard.state') as string}
          name="stateCode"
          model={model}
          options={dictionaries.STATES}
          mandatory
        />
        <AppInputDynamicPadding
          label={t('AddCard.zip') as string}
          model={model}
          name="zipCode"
          inputMask="99999"
          mandatory
        />

        <Spacer height={16} />
        <Observer>
          {() => (
            <BtButton
              block
              onPress={() => onAction()}
              disabled={!model?.canSave || model?.isSending}
              loading={model?.isSending}
            >
              {addModal ? t('AddCard.add-card') : t('AddCard.submit')}
            </BtButton>
          )}
        </Observer>
      </View>
    )
  },
)

export default {
  title: 'Type your Billing Address',
  component: AddressDetails,
  previous: 'CardholderDetails',
}
